import { Button } from "antd";

const CardButton = ({ className = "", loading, name, onNextStep }) => {
  return (
    <div className={`p-5 fixed  bottom-0 w-full max-w-2xl ${className}`}>
      <Button
        block
        className="primary-button-large justify-center items-center"
        loading={loading}
        onClick={onNextStep}
      >
        {name}
      </Button>
    </div>
  );
};

export default CardButton;
